module.exports = __webpack_public_path__ + "static/img/2.9b9d2c1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/10/eng/2.png
// module id = 71BA
// module chunks = 0